import { t } from "i18next";
import { useState } from "react";
import { countTimeExpired } from "../../Services/service";

export default function PaymentApplication() {
    const [objectDto, setObjectDto] = useState(
        {
            premium: "", poName: "",
            poNumber: "",
            poPhone: "", email: "",
            poAddress: "",
        });
    countTimeExpired(objectDto, setObjectDto);
    return (
        <>
            <div data-toggle="collapse" data-target="#content-box-0" className="header-box">
                <h2 className="title-box">{t("paymentinfo").toUpperCase()}</h2>
            </div>
            <div className="collapse in" id="content-box-0">
                <div className="border-box-sc row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div className="col-md-12 col-sm-12 col-xs-12 form-group">
                            <fieldset className="payment-information">
                                <div className="col-md-12">
                                    <label className="col-md-2 required">{t("policyapplicationnumber")}</label>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control j-required j-number j-policy" value={objectDto.poNumber}
                                            onChange={(e) => setObjectDto({ ...objectDto, poNumber: e.target.value })} />
                                    </div>
                                    <label className="col-md-2 required">{t("fullname")}</label>
                                    <div className="col-md-4 ">
                                        <input type="text" className="form-control j-required " value={objectDto.poName}
                                            onChange={(e) => setObjectDto({ ...objectDto, poName: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <label className="col-md-2 required">{t("phonemobile")}</label>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control j-required j-minlength " value={objectDto.poPhone}
                                            onChange={(e) => setObjectDto({ ...objectDto, poPhone: e.target.value })} />
                                    </div>
                                    <label className="col-md-2">{t("email1")}</label>
                                    <div className="col-md-4">
                                        <input type="text" className="form-control j-email" value={objectDto.email}
                                            onChange={(e) => setObjectDto({ ...objectDto, email: e.target.value })} />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <label className="col-md-2">{t("address")}</label>
                                    <div className="col-md-10">
                                        <input type="text" className="form-control" value={objectDto.poAddress}
                                            onChange={(e) => setObjectDto({ ...objectDto, poAddress: e.target.value })} />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <label className="col-md-2 required" style={{ fontWeight: "bold", color: "red" }}>{t("policypremium")}</label>
                                    <div className="col-md-10">
                                        <input type="text" className="j-required " value={objectDto.premium}
                                            onChange={(e) => setObjectDto({ ...objectDto, premium: e.target.value })} style={{ fontWeight: "bold", color: "red", textAlign: "right" }}
                                            onfocus="use_number(this)" onblur="use_text(this)" />
                                        <span id="premium-text" style={{ fontWeight: "bold", color: "red", textAlign: "right" }}>{" "}đồng</span>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="col-md-2" />
                                    <div className="col-md-10">
                                        <span id="" style={{ fontStyle: "italic", color: "red" }}>{t("paymentpremiumnote1")}</span>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="col-md-2" />
                                    <div className="col-md-10">
                                        <span id="" style={{ fontStyle: "italic", color: "red" }}>{t("paymentpremiumnote2")}</span>
                                    </div>
                                </div>
                            </fieldset>
                            <div className="footer-box-bg col-md-12 form-group left" style={{ display: "block" }} id="submitDiv">
                                <a id="btnPayment" className="btn-green btn-common">
                                    <i className=" fa fa-shopping-cart" />{" "}
                                    <span>{t("payment")}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};
